import React from 'react'
import type { StreakReward } from './useProgressionStore.js'

interface Props {
  reward: StreakReward
  streakBroken: boolean
  onClose: () => void
}

// Day icons for visual display
const DAY_ICONS = ['⚔️', '🛡️', '💎', '✨', '🔥', '⚡', '👑']

export function StreakRewardModal({ reward, streakBroken, onClose }: Props): React.ReactElement {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1200,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        pointerEvents: 'all',
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Tägliche Belohnung"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'linear-gradient(160deg, #12082a 0%, #1a0a3a 100%)',
          border: '2px solid #C9A84C', borderRadius: 16,
          padding: 32, maxWidth: 320, width: '90%', textAlign: 'center',
        }}
      >
        {streakBroken && (
          <p style={{ color: '#e53935', fontSize: 12, marginBottom: 8 }}>
            Streak verloren — aber heute neu gestartet!
          </p>
        )}
        <div style={{ fontSize: 56, marginBottom: 8 }}>{DAY_ICONS[(reward.day - 1) % 7]}</div>
        <h2 style={{ color: '#C9A84C', fontSize: 22, marginBottom: 4 }}>
          Tag {reward.day} Login-Belohnung
        </h2>
        <p style={{ color: '#aaa', fontSize: 13, marginBottom: 16 }}>
          {reward.day === 7 ? '7-Tage-Streak abgeschlossen!' : `Streak: ${reward.day} Tag${reward.day > 1 ? 'e' : ''}`}
        </p>
        <div style={{
          background: 'rgba(201,168,76,0.15)', border: '1px solid #C9A84C',
          borderRadius: 10, padding: '12px 20px', marginBottom: 20,
          fontSize: 20, fontWeight: 'bold', color: '#fff',
        }}>
          {reward.label}
        </div>
        {/* 7-day progress dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 20 }}>
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} style={{
              width: 24, height: 24, borderRadius: '50%',
              background: i < reward.day ? '#C9A84C' : '#333',
              border: i === reward.day - 1 ? '2px solid #fff' : '2px solid transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, color: i < reward.day ? '#000' : '#666',
            }}>{i + 1}</div>
          ))}
        </div>
        <button
          onClick={onClose}
          autoFocus
          style={{
            background: '#C9A84C', color: '#000', border: 'none',
            borderRadius: 8, padding: '12px 32px',
            fontSize: 15, fontWeight: 'bold', cursor: 'pointer',
            minHeight: 44, minWidth: 120,
          }}
        >
          Einsammeln!
        </button>
      </div>
    </div>
  )
}
